import css from 'styled-jsx/css';
import { Breakpoints, Colors, FontSizes } from '../../../styles';

const { minTablet, minDesktop } = Breakpoints;
export default css`
     {

        .fadeAway {
            animation-name: fadeAway;
            transition: opacity 500ms linear;
          }

          @keyframes fadeAway {
            from {
                transform:translate(0);
                opacity: 1;
            }
          
            to {
                transform:translate(9999px);
                opacity: 0;  
            }
          }

        @keyframes slideOutDown {
            from {
              transform: translate3d(0, 0, 0);
            }
          
            to {
              visibility: hidden;
              display: none;
              transform: translate3d(0, 100%, 0);
            }
          }
          
          .slideOutDown {
            animation-name: slideOutDown;
          }

        .animated {
            animation-duration: 300ms;
            animation-fill-mode: both;
          }

        @keyframes slideInUp {
            from {
              transform: translate3d(0, 100%, 0);
              visibility: visible;
            }
          
            to {
              transform: translate3d(0, 0, 0);
            }
          }
          
          .slideInUp {
            animation-name: slideInUp;
          }

          @keyframes slideInDown {
            from {
              transform: translate3d(0, -100%, 0);
              visibility: visible;
            }
          
            to {
              transform: translate3d(0, 0, 0);
            }
          }
          
          .slideInDown {
            animation-name: slideInDown;
          }


        .textLeft {
            text-align: left!important;
        }
        .ps {
            overflow: hidden!important;
            overflow-anchor: none;
            -ms-overflow-style: none;
            touch-action: auto;
            -ms-touch-action: auto;
        }

        .nav {
            display: flex;
            flex-wrap: wrap;
            padding-left: 0;
            margin-bottom: 0;
            list-style: none;
        }

        .flexColumn {
            flex-direction: column;
        }

        .pcodedNavbar.navbarCollapsed {
            width: 66px;
            height: 100%;
            transition: all .3s ease-in-out;
        }

        .pcodedNavbar .pcodedInnerNavbar{
            flex-direction: column;
        }
        
        :global(html[dir=rtl]) .pcodedNavbar .sidemenu li.active:after {
            right: unset;
            left: 0;
            top: 0;
        }


        .navbarCollapsed .bBrand .bTitle {
            -webkit-transform: rotateY(-90deg);
            transform: rotateY(-90deg);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            opacity: 0;
            transition: all .1s ease-in-out;
        }

        .navbarCollapsed .sideContent ul {
            -webkit-transform: rotateY(-90deg);
            transform: rotateY(-90deg);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            opacity: 0;
            transition: all .3s ease-in-out;
        }

        .layout1 .pcodedNavbar .layout1Nav {
            display: flex;
            align-items: stretch;
            height: auto;
            min-height: 100%;
        }


        .layout1 .pcodedNavbar .sidemenu {
            box-shadow: inset -1px 0 0 0 rgba(181,189,202,.2);
        }

        .layout1 .pcodedNavbar .sidemenu li.active {
            color: #feee00;
        }

        .pcodedNavbar.menuposFixed .scrollDiv.navbarContent {
            height: calc(100% - 70px);
            min-height: calc(100% - 70px);
        }

        .pcodedNavbar .headerLogo+.scrollDiv {
            float: left;
            display: inline-block;
        }

        .pcodedNavbar{
            display:block;
            z-index:1029;
            position:absolute;
            transition:all .3s ease-in-out;
            width:264px;
            height:100%;
            top:0;
            background:#404553;
            color:#b5bdca
        }
        
        .layout1 .pcodedNavbar .sidemenu li a {
            font-size: 18px;
            text-align: center;
            padding: 20px 20px;
            position: relative;
            cursor: pointer;
            text-align: text-center;
        }

        .navLink {
            display: block;
            padding: 10px 24px;
        }

        .pcodedNavbar .navbarContent, .pcodedNavbar .navbarWrapper {
            width: 100%;
            height: 100%;
        }

        .pcodedNavbar.menuposFixed {
            position: fixed;
            height: 100vh;
            min-height: 100vh;
        }

        .pcodedNavbar .navbarContent, .pcodedNavbar .navbaWwrapper {
            width: 100%;
            height: 100%;
        }

        .pcodedNavbar .headerLogo{
            position:relative;
            align-items:center;
            display:inline-flex;
            float:left;
            background: #fff;
            height:50px;
            text-align:center;
            width:224px;
            margin-right:0;
            padding: 10px 15px 10px 25px;
            transition:all .3s ease-in-out;
            // box-shadow:0 1px 0 0 rgba(181,189,202,.2),7px 0 15px 0 rgba(69,90,100,.09);
        }

        .layout1 .pcodedNavbar .headerLogo {
            padding: 10px 15px 10px 25px;
        }

        .pcodedNavbar .headerLogo .logoDark{
            display:none
        }
        .pcodedNavbar .headerLogo .logoThumb{
            -webkit-transform:rotateY(-90deg);
            transform:rotateY(-90deg);
            opacity:0;
            position:absolute;
            transition:unset
        }
        .pcodedNavbar .headerLogo+.scrollDiv{
            float:left;
            display:inline-block
        }

        .bBrand {
            display: flex;
            align-items: center;
        }

        .pcodedNavbar.navbarCollapsed .headerLogo .mobileMenu {
            -webkit-transform: rotateY(-90deg);
            transform: rotateY(-90deg);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            opacity: 0;
        }


        .mobileMenu.on span {
            background-color: transparent;
        }
        .mobileMenu span {
            position: relative;
            display: block;
            width: 100%;
            height: 2px;
            background-color: rgba(255,255,255,.8);
            transition: all .3s ease-in-out;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            border-radius: 2px;
        }

        .mobileMenu.on span:before {
            -webkit-transform: rotate(45deg) translate(4px,4px);
            transform: rotate(45deg) translate(4px,4px);
        }
        
        .mobileMenu.on span:after, .mobileMenu.on span:before {
            height: 2px;
            width: 100%;
        }
        .mobileMenu span:before {
            top: -5px;
            width: 40%;
        }
        .pcodedNavbar ul {
            padding-left: 0;
            list-style: none;
            margin-bottom: 0;
        }

        .navbarBrand {
            display: inline-block;
            padding-top: .3125rem;
            padding-bottom: .3125rem;
            margin-right: 1rem;
            font-size: 1.25rem;
            line-height: inherit;
            white-space: nowrap;
        }

        .pcodedNavbar .sidemenu li a {
            font-size: 22px;
            padding: 10px 20px;
            position: relative;
            cursor: pointer;
        }

        .pcodedNavbar .sidemenu li a:after {
            content: "";
            position: absolute;
            height: 1px;
            width: 60%;
            left: 20%;
            bottom: 0;
            border-bottom: 1px solid rgba(181,189,202,.2);
        }

        .pcodedNavbar .sidemenu li.active:after {
            content: "";
            background-color: #feee00;
            z-index: 1027;
            position: absolute;
            right: 0;
            top: 0;
            width: 3px;
            height: 100%;
        }

        :global(html[dir=rtl]) .pcodedNavbar .sidemenu li.active:after {
            right: unset
            left: 0;
            top: 0;
        }



        .layout1 .pcodedNavbar .sidemenu li {
            position: relative;
        }


        .bBrand .bBg {
            background: #feee00;
            border-radius: 3px;
            width: 30px;
            height: 30px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            color: #fff;
        }

        .bBrand .bTitle {
            margin-left: 20px;
            font-weight: 400;
            color: #fff;
            font-size: 22px;
        }


        .pcodedNavbar .mobileMenu{
            display:flex;
            align-items:center;
            justify-content:center;
            width:37px;
            height:70px;
            position:absolute;
            right:10px;
            top:0;
            padding:0 10px;
            transition:all .3s ease-in-out
        }
        .appNav {
            background: ${Colors.body};
            padding: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .eachApp {
            padding: 10px;
            display: block;
            border-radius: 4px;
            font-weight: 600;
            color: ${Colors.bgGross};
            margin: 15px 0;
        }

        .layout1 .pcodedNavbar .sideContent {
            flex: 1 1 0;
            display: inline-block;
        }

        .layout1 .pcodedNavbar .sideContent.fadeAway {
            flex: 0;
        }

        .layout1 .pcodedNavbar .sideContent .sidelink .pcodedInnerNavbar li.pcodedMenuCaption {
            font-size: 20px;
            padding: 20px 15px 16px 18px;
        }
        .pcodedNavbar .pcodedInnerNavbar li.pcodedMenuCaption {
            font-size: 11px;
            font-weight: 400;
            padding: 25px 15px 15px 28px;
            text-transform: capitalize;
            position: relative;
        }
        .pcodedNavbar .pcodedInnerNavbar li {
            position: relative;
        }
        .pcodedNavbar .pcodedMenuCaption {
            color: #8090a5;
        }

        .layout1 .pcodedNavbar .sideContent .sidelink .pcodedInnerNavbar>li>a {
            padding: 15px 10px 15px 20px;
            box-sizing: border-box;
        }
        .pcodedNavbar .pcodedInnerNavbar li>a {
            text-align: left;
            padding: 15px 10px 15px 20px;
            display: block;
            border-radius: 0;
            position: relative;
        }

        :global(html[dir='rtl']) .pcodedNavbar .pcodedInnerNavbar li>a {
            text-align: right;
        }

        .layout1 .pcodedNavbar .sideContent .sidelink .pcodedInnerNavbar li.pcodedMenuCaption:after {
            content: "";
            position: absolute;
            height: 1px;
            width: 40px;
            left: 18px;
            bottom: 13px;
            border-bottom: 1px solid rgba(181,189,202,.2);
        }



        .pcodedNavbar .pcodedInnerNavbar{
            flex-direction:column
        }
        .pcodedNavbar .pcodedInnerNavbar li{
            position:relative
        }
        .pcodedNavbar .pcodedInnerNavbar li>a{
            text-align:left;
            padding:7px 10px 7px 20px;
            display:block;
            border-radius:0;
            position:relative
        }

        .mainTitle {
            display: block;
            font-size: 18px;
            color: #a5a5a5;
            font-weight: bold;
            text-align: left;
        }

        .subTitle {
            display: block;
            font-size: 15px;
            text-align: left;
            line-height: 14px;
            color: #404553;
            font-weight: bold;
        }


        .pcodedNavbar.navbarCollapsed .headerLogo {
            width: 26px;
            padding: 10px 15px 10px 25px
        }

        :global(html[dir=rtl]) .bBrand .bTitle {
            margin-left: unset;
            margin-right: 20px;
        }

        .pcodedNavbar .pcodedInnerNavbar>li.active>a, .pcodedNavbar .pcodedInnerNavbar>li.pcodedTrigger>a {
            background: #1d2431;
            color: #fff;
        }

        .bBg .logo {
            background: #fff;
        }

        .appMenu {
            flex: 1;
        }
        :global(.appSettings) {
            color: ${Colors.bgGross} !important;
            padding: 10px;
            display: block;
            border-radius: 4px;
            font-weight: 600;
            margin: 15px 0;
        }
        .appNavFooter {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px 0;
        }
        .current {
            background: ${Colors.bgGross};
            color: ${Colors.body};
        }
        // .container .mobileWrapper,
        // .container .mobileMenu {
        //     display: flex;
        //     align-items: center;
        //     justify-content: space-between;
        //     padding: 15px;
        //     position: fixed;
        //     width: 100%;
        //     z-index: 200;
        //     background: ${Colors.bgGross};
        // }

        .back {
            color: ${Colors.genHappy};
            font-size: 0.85rem;
            font-weight: 600;
            display: block;
            background: ${Colors.bgPrimary};
            border-bottom: 1px solid ${Colors.border};
            padding: 5px 10px;
            box-sizing: border-box;
        }

        .help {
            font-size: 1rem;
            font-weight: 600;
            background: ${Colors.bgPrimary};
            padding: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .helpIcon {
            margin: 0 10px;
        }

        .help div {
            display: inline;
        }

        .toggleIcon {
            transition: 0.7s;
            display: none;
        }

        .rotate {
            transition: 0.7s;
            transform: rotate(-180deg);
        }

        .hover {
            position: absolute;
        }

        :global(.menuIcon) {
            // margin: 0 5px;
            min-width: 20px;
            font-size: 15px;
        }

        @media ${minTablet} {
            .sidePanelWrapper .logoWrapper .logo {
                width: 150px !important;
                height: auto;
            }
            .mobileMenu .logoWrapper .logo {
                width: 100% !important;
            }
        }

        .mobileWrapper .logoWrapper,
        .mobileMenu .logoWrapper {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .mobileWrapper .logoWrapper a,
        .mobileMenu .logoWrapper a {
            width: 120px;
        }

        .mobileWrapper .logoWrapper .logo,
        .mobileMenu .logoWrapper .logo {
            width: 100%;
            height: auto;
        }

        .sidePanel .logoWrapper.desktopLogo {
            display: none;
        }

        .menuItemTitle {
            margin-left: 14px;
        }

        :global(html[dir='rtl']) .menuItemTitle {
            margin-left: unset;
            margin-right: 14px;
        }

        .hamburger {
            padding: 15px;
            display: inline-block;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
            transition-property: opacity, filter;
            transition-duration: 0.15s;
            transition-timing-function: linear;
            font: inherit;
            color: inherit;
            text-transform: none;
            background-color: transparent;
            border: 0;
            margin: 0;
            overflow: visible;
            line-height: 1.4;
        }

        :global(html[dir='rtl']) .hamburger {
            left: unset;
            right: 0;
        }

        .hamburger:hover {
            opacity: 0.7;
        }

        .hamburgerBox {
            width: 18px;
            height: 14px;
            display: inline-block;
            position: relative;
        }

        .hamburgerInner {
            display: block;
            top: 50%;
        }

        .hamburgerInner,
        .hamburgerInner::after,
        .hamburgerInner::before {
            width: 18px;
            height: 2px;
            background-color: ${Colors.body};
            position: absolute;
            transition-property: transform;
            transition-duration: 0.15s;
            transition-timing-function: ease;
        }

        .hamburgerInner::after,
        .hamburgerInner::before {
            content: '';
            display: block;
        }

        .hamburgerInner::before {
            top: -7px;
        }

        .hamburgerInner::after {
            bottom: -7px;
        }

        .hamburgerSqueeze .hamburgerInner {
            transition-duration: 0.075s;
            transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }

        .hamburgerSqueeze .hamburgerInner::before {
            transition: top 0.075s 0.12s ease, opacity 0.075s ease;
        }

        .hamburgerSqueeze .hamburgerInner::after {
            transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }

        .hamburgerSqueeze.isActive .hamburgerInner {
            transform: rotate(45deg);
            transition-delay: 0.12s;
            transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }

        .hamburgerSqueeze.isActive .hamburgerInner::before {
            top: 0;
            opacity: 0;
            transition: top 0.075s ease, opacity 0.075s 0.12s ease;
        }

        .hamburgerSqueeze.isActive .hamburgerInner::after {
            bottom: 0;
            transform: rotate(-90deg);
            transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
        }

        .sidePanelWrapper,
        .sidePanelMobileMenu {
            width: 80%;
            position: fixed;
            box-sizing: border-box;
            max-width: 265px;
            top: 0;
            left: -100%;
            display: flex;
            bottom: 0;
            z-index: 20;
            transition: all ease-in-out 0.4s;
        }

        :global(html[dir='rtl']) .sidePanelWrapper,
        :global(html[dir='rtl']) .sidePanelMobileMenu {
            right: -100%;
            left: unset;
        }

        .sidePanelWrapper .sidePanel,
        .sidePanelMobileMenu .sidePanel {
            padding: 20px;
            background: ${Colors.bgGross};
            min-height: 100vh;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
        }

        .sidePanelWrapper .back {
            margin: -20px -20px 20px -20px;
        }

        .sidePanelWrapper .help {
            margin: 20px -20px -20px -20px;
        }

        .sidePanelWrapper:before,
        .sidePanelMobileMenu:before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.4);
            z-index: -1;
            opacity: 0;
            pointer-events: none;
            transition: all ease-in-out 0.4s;
        }

        :global(html[dir='rtl']) .sidePanelWrapper:before {
            left: unset;
            right: 0;
        }

        .signoutWrapper {
            padding: 20px 15px;
        }

        .storeName {
            font-weight: 600;
            font-size: ${FontSizes.mdBase};
        }

        .userName {
            font-size: ${FontSizes.mdBase};
            color: ${Colors.sub};
        }

        :global(.btn) {
            width: 100%;
            margin-top: 15px;
        }

        .sidePanelWrapper.mobileSidePanel,
        .sidePanelMobileMenu.mobileSidePanel {
            left: 0;
            opacity: 1;
            z-index: 1000;
            overflow: auto;
        }

        :global(html[dir='rtl']) .sidePanelWrapper.mobileSidePanel {
            left: unset;
            right: 0;
        }

        .sidePanelWrapper.mobileSidePanel:before {
            opacity: 1;
            pointer-events: auto;
        }

        .sidePanelWrapper .logoWrapper {
            padding: 3px 15px 15px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .sidePanelWrapper .logoWrapper a {
            width: 120px;
        }

        .sidePanelWrapper .logoWrapper .logo {
            width: 100%;
            height: auto;
        }

        .menuList {
            padding: 15px 10px 15px 20px;
            color: ${Colors.genInactive};
            font-size: ${FontSizes.mdBase};
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            transition: 0.3s all linear;
        }

        .iconNav {
            margin-right: 10px;
            min-width: 20px;
        }

        .menuList i {
            color: ${Colors.genInactive} !important;
            font-size: 15px;
            padding-right: 14px;
        }

        .menuList.active,
        .menuList:hover {
            background: ${Colors.bgPrimary};
            box-shadow: 0 2px 2px 0 ${Colors.getRGBA(Colors.shadow, 0.2)};
            color: ${Colors.body};
        }

        .menuList.active i,
        .menuList:hover i {
            color: ${Colors.body} !important;
            font-size: 17px;
        }

        @media ${minTablet} {
        }
        @media ${minDesktop} {
            .toggleIcon {
                display: inline-block;
            }

            .container .mobileWrapper {
                display: none;
            }

            .smallDeviceLogo {
                display: none;
            }

            .sidePanelWrapper {
                width: unset;
                position: unset;
                max-width: unset;
                top: unset;
                left: unset;
                transition: 0.7s;
            }

            .smallSidePanel {
                display: flex;
                transition: 0.7s;
            }

            .smallSidePanel .sidePanel {
                padding: 20px 5px;
            }
            .smallSidePanel .back {
                margin: -20px -3px 20px -3px;
            }
            .smallSidePanel .help {
                margin: 20px -3px -20px -3px;
            }

            .smallSidePanel .menuList {
                align-items: center;
                justify-content: center;
                padding: 10px;
            }
            .smallSidePanel :global(.menuIcon) {
                margin-right: 0;
                font-size: 1.5rem;
            }
            .sidePanelWrapper:before {
                position: unset;
                top: unset;
                left: unset;
                bottom: unset;
                width: unset;
                background-color: unset;
            }

            .sidePanelWrapper .logoWrapper .logo.smallLogo {
                width: 25px !important;
            }

            .sidePanel .logoWrapper.desktopLogo {
                display: block;
            }

            .sidePanel .logoWrapper.mobileLogo {
                display: none;
            }

            .menuItemTitle {
                display: none;
            }
            .menuItemTitle.show {
                display: block;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/common/mainMenu/styles.js